

import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/easing.st.css.js";
import "../Tooltip/Tooltip.st.css.js";
import "../Foundation/stylable/opacity.st.css.js";
import "../Foundation/stylable/border.st.css.js";
import "../Text/Text.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_220_3_AddItem";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_220_3_AddItem__root","icon":"wds_1_220_3_AddItem__icon","illustration":"wds_1_220_3_AddItem__illustration","contentContainer":"wds_1_220_3_AddItem__contentContainer","content":"wds_1_220_3_AddItem__content","textWrapper":"wds_1_220_3_AddItem__textWrapper","textContent":"wds_1_220_3_AddItem__textContent","subtitle":"wds_1_220_3_AddItem__subtitle","tooltip":"wds_1_220_3_AddItem__tooltip"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-add-item-border-color-disabled":"--wds-add-item-border-color-disabled","wds-add-item-border-color-hover":"--wds-add-item-border-color-hover","wds-add-item-border-color":"--wds-add-item-border-color","wds-add-item-border-dashed-radius":"--wds-add-item-border-dashed-radius","wds-add-item-border-radius":"--wds-add-item-border-radius","wds-add-item-fill-pressed":"--wds-add-item-fill-pressed","wds-add-item-fill-disabled":"--wds-add-item-fill-disabled","wds-add-item-fill-hover":"--wds-add-item-fill-hover","wds-add-item-fill":"--wds-add-item-fill","wds-add-item-label-color":"--wds-add-item-label-color","wds-add-item-padding-horizontal-large":"--wds-add-item-padding-horizontal-large","wds-add-item-padding-vertical-large":"--wds-add-item-padding-vertical-large","wds-add-item-padding-vertical-medium":"--wds-add-item-padding-vertical-medium","wds-add-item-padding-vertical-small":"--wds-add-item-padding-vertical-small","wds-add-item-padding-vertical-tiny":"--wds-add-item-padding-vertical-tiny","wds-color-fill-standard-tertiary":"--wds-color-fill-standard-tertiary","wds-color-text-disabled":"--wds-color-text-disabled","wds-color-text-standard-secondary":"--wds-color-text-standard-secondary","wds-shadow-focus-standard":"--wds-shadow-focus-standard","wds-space-100":"--wds-space-100","wds-space-200":"--wds-space-200"}; 




